import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const HandleError = error => {
    toast.configure();
    
    if (error.message === "Unauthorized please login again!" || error.message === "Unauthorized" || error.message === "Token has expired") {
        //localStorage.removeItem("auth_security");
        toast.error(error.message)
        setTimeout(() => {
            //window.location.href = "/"
        }, 700);
    }
};

export default HandleError;
